<template>
  <v-page-content>
    <div v-if="isLoaded" :class="classesForAll">
      <h3 v-if="$router.currentRoute.path === '/profile'" class="profile-header">
        <em class="fas fa-1x fa-user"></em>
        Профиль</h3>
      <div v-else-if="$router.currentRoute.path === ('/student/list/' + $route.params.id)">
        <h5 class="profile-header">
          <router-link to=".">Список учеников/</router-link>
        </h5>
        <h3 class="profile-header" v-if="(hasRole('admin') || currUser.id === profile.id)">
          {{ initials }}
        </h3>
        <h3 class="profile-header" v-else>
          Рег. номер: {{ profile.id }}
        </h3>
      </div>
      <b-form @submit="onSubmit" @reset="onReset">
        <div class="profile-photo-div">
          <b-form-group id="input-group-1" label="Фотография" label-for="input-1" v-if="profile">
            <div style="text-align: center;" class="position-relative">
              <img
                :src='profile.avatarFile
                  ? ("/api/files/" + profile.avatarFile.physicalName)
                  : defaultAvatar'
                @error="$event.target.src = defaultAvatar"
                id='profilePhoto'
                alt=""
                class="mx-auto"
              >
              <b-button
                v-if="changeMod"
                @click="changeImage"
                v-b-tooltip.hover
                title="Изменение аватарки. Форматы - png или jpg (jpeg). Максимальный размер - 5MB."
                variant="primary"
                class="fa fa-edit position-absolute change-profile-avatar-button"
              ></b-button>
              <b-button
                v-if="changeMod"
                @click="dropImage"
                v-b-tooltip.hover
                title="Сброс аватарки"
                variant="primary"
                class="fa fa-times position-absolute delete-profile-avatar-button"
              ></b-button>
            </div>
            <b-form-file class="mt-3"
                         plain @change='loadImage($event.target)' hidden
                         id='imageFileInput' ref="file-input"
                         accept="image/png, image/jpeg"></b-form-file>
            <div class='buttonsFormBlock' v-if="profileUserId === currUser.id">
              <b-button v-b-modal.modal-change-password
                        variant="outline-primary" id='buttonChangePassword'><em
                class="fas fa-exchange-alt" aria-hidden="true"></em> Сменить пароль
              </b-button>
              <b-button variant="outline-primary" @click='changeModActive()' id='buttonChangeMod'>
                <em class="fas fa-pen" aria-hidden="true"></em>
                Редактировать
              </b-button>
              <b-button type="submit" variant="primary" id='buttonSave'>Сохранить</b-button>
              <b-button type="reset" variant="outline-primary" id='buttonCancel'>Отмена</b-button>
            </div>
            <div class='buttonsFormBlock' v-else-if="false">
              <b-button variant="outline-primary" id='buttonGoToMessages' @click='goToMessages()'><em
                class="far fa-envelope"></em> Написать
              </b-button>
            </div>
          </b-form-group>
        </div>
        <div class='row' id='divInputsWithoutImage'>
          
          <b-form-group :class="classesForInputs2_5" id="input-group-2"
                        label="Фамилия" label-for="input-2" disabled
                        v-if="profile && (hasRole('admin') || currUser.id === profile.id)">
            <b-form-input id="input-2" v-model="profile.surname" type="text" required
                          :disabled='!changeMod'></b-form-input>
          </b-form-group>
          <b-form-group :class="classesForInputs2_5" id="input-group-3"
                        label="Имя" label-for="input-3" v-if="profile && (hasRole('admin') || currUser.id === profile.id)">
            <b-form-input :disabled='!changeMod' id="input-3" v-model="profile.name" type="text"
                          required></b-form-input>
          </b-form-group>
          <b-form-group :class="classesForInputs2_5" id="input-group-4"
                        label="Отчество" label-for="input-4"
                        v-if="profile && (hasRole('admin') || currUser.id === profile.id)">
            <b-form-input :disabled='!changeMod' id="input-4" v-model="profile.midname"
                          type="text"></b-form-input>
          </b-form-group>
          <b-form-group :class="classesForInputs2_5" id="input-group-5"
                        label="Почта" label-for="input-5"
                        v-if="profile && (hasRole('admin') || currUser.id === profile.id)">
            <b-form-input disabled id="input-5" v-model="profile.email"
                          type="email" required></b-form-input>
          </b-form-group>
          <b-form-group :class="classesForInput6" id="input-group-6"
                        label="Телефон" label-for="input-6" v-if="profile && (hasRole('admin') || currUser.id === profile.id)">
            <b-form-input :disabled='!changeMod' id="input-6" v-model="profile.phone"
                          type="tel" v-mask="'+7-9##-###-##-##'"></b-form-input>
          </b-form-group>
          <b-form-group :class="classesForInput7" id="input-group-7"
                        label="Дата рождения" label-for="input-7"
                        v-if="profile && (hasRole('admin') || currUser.id === profile.id)">
            <b-form-input :disabled='!changeMod' id="input-7" v-model="profile.birthday"
                          type="date" :max="currDate"></b-form-input>
          </b-form-group>
          <b-form-group :class="classesForInput8" id="input-group-8" label="Пол"
                        label-for="input-8">
            <b-form-select :disabled='!changeMod' v-model="profile.gender" :options="genders">
              <template slot="first">
                <option :value="null" disabled></option>
              </template>
            </b-form-select>
          </b-form-group>
          <b-form-group :class="classesForInput9" id="input-group-9" label="Роль"
                        label-for="input-9" v-if="roles">
            <b-form-input id="input-9" v-model="roles" type="text" disabled></b-form-input>
          </b-form-group>
          <b-form-group :class="classesForInput10" id="input-group-10"
                        label="Организация" label-for="input-10"
                        v-if="profile">
            <b-form-input id="input-10"
                v-model="organizations.filter((p) => profile.organizationId === p.id)[0].title"
                type="text" disabled></b-form-input>
          </b-form-group>
          <b-form-group v-if='profile.studentProfile' :class="classesForInput11"
                        id="input-group-11" label="Класс"
                        label-for="input-11">
            <b-form-input id="input-11" v-model="profile.studentProfile.class"
                          type="text" disabled></b-form-input>
          </b-form-group>
          <b-form-group :class="classesForInput8" id="input-group-8" label="Гражданство" v-if='profile.studentProfile'
                        label-for="input-8">
            <b-form-select :disabled='!changeMod' v-model="profile.studentProfile.citizenship" :options="countriesOption"></b-form-select>
          </b-form-group>
          <b-form-group :class="classesForInput14" id="input-group-8" label="Средний балл" v-if='profile.studentProfile'
                        label-for="input-8">
            <b-form-select :disabled='!changeMod' v-model="profile.studentProfile.averageMarks" :options="averageMarksOption"></b-form-select>
          </b-form-group>
          <b-form-group :class="classesForInput13" id="input-group-2"
                        label="Рег. номер" label-for="input-2"
                        v-if="profile && (hasRole('admin'))">
            <b-form-input disabled id="input-3" type="text" :value="profile.id"></b-form-input>
          </b-form-group>
          <b-form-group class="col-md-12" id="input-group-check-notifications"
                        label-for="input-check-email-notifications"
                        v-if="profile && (hasRole('admin') || currUser.id === profile.id)">
            <b-form-checkbox id="input-check-email-notifications"
                        v-model="profile.isEmailNotification"
                         :disabled='!changeMod'
                         value="true"
                         unchecked-value="false">Получение уведомлений на почту</b-form-checkbox>
          </b-form-group>
          <b-form-group :class='classesForInput12' v-if='profile.studentProfile'
                        id="input-group-12" label="Портфолио"
                        label-for="textarea-1">
            <b-form-textarea :disabled='!changeMod' id="textarea-1"
                             v-model="profile.studentProfile.about"
                             :rows="portfolioRows" no-resize></b-form-textarea>
          </b-form-group>
        </div>
      </b-form>
      <b-modal id="modal-change-password" title="Смена пароля"
               header-bg-variant="primary" header-text-variant="light"
               hide-footer ref="modal-change-password" no-close-on-esc no-close-on-backdrop>
        <template slot="modal-header">
          <div style="font-size: 18px" class="mx-auto">Смена пароля</div>
          <em class="fas fa-lg fa-remove mt-1" aria-hidden="true" @click="closeModalChangePassword"
             style="cursor: pointer"></em>
        </template>
        <div>
          <b-form @submit="onSubmitChangePass" @reset="closeModalChangePassword">
            <b-form-group id="input-group-current-password"
                          label="Введите текущий пароль" label-for="input-current-password">
              <b-form-input
                id="input-current-password"
                v-model="changePassForm.currentPass"
                required
                type="password"
              ></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-new-first-password"
                          label="Введите новый пароль" label-for="input-new-first-password">
              <b-form-input
                id="input-new-first-password"
                v-model="changePassForm.newFirstPass"
                required
                minlength="12"
                v-b-tooltip.hover
                title="Для большей надёжности рекомендуется использовать
                  буквы разных регистров и цифры"
                type="password"
              ></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-new-second-password"
                          label="Повторите новый пароль" label-for="input-new-second-password">
              <b-form-input
                id="input-new-second-password"
                v-model="changePassForm.newSecondPass"
                required
                minlength="12"
                type="password"
              ></b-form-input>
            </b-form-group>
            <b-button id="buttonSubmitChangePassword" type="submit"
                      variant="primary">Изменить пароль</b-button>
            <b-button id="buttonCancelChangePassword" type="reset"
                      variant="outline-primary">Отмена</b-button>
          </b-form>
        </div>
      </b-modal>
      <div
        id="olympicDiv"
        v-if="rowDataOlympic && rowDataOlympic.length"
        :class="classesForOlympics"
      >
        <h5>Участие в мероприятиях</h5>
        <div class="row">
          <ag-grid-vue style="height: 300px !important;"
            class="ag-theme-material ag-grid-vue-profile col-md-12 custom-table"
            :columnDefs="columnOlympicDefs"
            :gridOptions="gridOptions"
            :rowData="rowDataOlympic"
            rowSelection="single"
            @grid-ready="onGridReadyOlympic"
            @rowSelected="getSelectedRowsOlympic"
            @gridSizeChanged="onGridSizeChangedOlympic"
            @column-resized="onColumnResizedOlympic">
          </ag-grid-vue>
        </div>
      </div>
      <div
        id="coursesDiv"
        v-if="rowDataCourses && rowDataCourses.length"
        :class="classesForCourses"
      >
        <h5>Прохождение курсов</h5>
        <div class="row">
          <ag-grid-vue style="height: 300px !important;"
            class="ag-theme-material ag-grid-vue-profile col-md-12 custom-table"
            :columnDefs="columnCoursesDefs"
            :gridOptions="gridOptions"
            :rowData="rowDataCourses"
            rowSelection="single"
            @grid-ready="onGridReadyCourse"
            @rowSelected="getSelectedRowsCourse"
            @gridSizeChanged="onGridSizeChangedCourse"
            @column-resized="onColumnResizedCourse">
          </ag-grid-vue>
        </div>
      </div>
      <div
        id="simDiv"
        v-if="(profile ? profile.simulators && profile.simulators.length : false) &&
          hasRole('student')"
        :class="classesForSim"
      >
        <h5>Работа на тренажерах</h5>
        <div class="row">
          <ag-grid-vue style="height: 300px !important;"
            class="ag-theme-material ag-grid-vue-profile col-md-12"
            :columnDefs="columnSimsDefs"
            :gridOptions="gridOptions"
            :rowData="profile ? profile.simulators : null"
            rowSelection="single"
            @grid-ready="onGridReadySim"
            @rowSelected="getSelectedRowsCourse"
            @gridSizeChanged="onGridSizeChangedSim"
            @column-resized="onColumnResizedSim">
          </ag-grid-vue>
        </div>
      </div>
      <b-modal ref="confirm-submit-modal" title="Подтверждение">
        <p>
        Контент будет невозможно изменить до проверки специалистом по режиму.<br>
        Продолжить?
        </p>
      </b-modal>
    </div>
  </v-page-content>
</template>

<script>
import moment from 'moment'
import { mapGetters, mapActions } from 'vuex'
import { AgGridVue } from 'ag-grid-vue'
import { mask } from 'vue-the-mask'
import UserMixin from '@/components/helpers/mixins/user-mixin'
import AG_GRID_LOCALE_RU from '@/config/locale.ru'
import COUNTRIES from "@/components/helpers/countries-to-select.json"


function simNameFormatter(params) {
  return params.data.trainingSession.simulator.contentObject.title
}

function dateFormatter(params) {
  return moment(params.data.trainingSession.createdAt).local().format('D.M.Y H:mm:ss')
}

export default {
  name: 'Profile',
  directives: { mask },
  components: {
    'ag-grid-vue': AgGridVue
  },
  data() {
    return {
      windowWidth: null,
      changeMod: false,
      isLoaded: false,
      currDate: (new Date()).toISOString().split('T')[0],
      rowDataOlympic: null,
      rowDataCourses: null,
      columnOlympicDefs: [
        {
          headerName: '№',
          field: 'numb',
          suppressSizeToFit: true,
          width: 70
        },
        {
          headerName: 'Мероприятие',
          field: 'title',
          width: 300,
          minWidth: 300,
          cellStyle: { 'justify-content': 'left !important' }
        },
        {
          headerName: 'Предмет',
          field: 'subjectOlympiad',
          suppressSizeToFit: true,
          width: 150
        },
        {
          headerName: 'Этап',
          field: 'stageOlympiad',
          suppressSizeToFit: true,
          width: 170
        },
        {
          headerName: 'Результат',
          field: 'resultOlympiad',
          suppressSizeToFit: true,
          width: 150
        }
      ],
      columnCoursesDefs: [
        {
          headerName: '№',
          field: 'numb',
          suppressSizeToFit: true,
          width: 70,
          cellStyle: { cursor: 'pointer' }
        },
        {
          headerName: 'Курс',
          field: 'title',
          width: 300,
          minWidth: 300,
          cellStyle: { 'justify-content': 'left !important', cursor: 'pointer' }
        },
        {
          headerName: 'Прогресс',
          field: 'progressCourse',
          suppressSizeToFit: true,
          width: 130,
          cellStyle: { cursor: 'pointer' }
        }
      ],
      columnSimsDefs: [
        {
          headerName: 'Тренажер',
          field: 'simName',
          valueFormatter: simNameFormatter
        },
        {
          headerName: 'Дата',
          field: 'date',
          width: 160,
          valueFormatter: dateFormatter
        },
        {
          headerName: 'Роль',
          field: 'role',
          width: 160
        },
        {
          headerName: 'Оценка',
          field: 'mark',
          width: 100
        }
      ],
      gridOlympicApi: null,
      gridCourseApi: null,
      gridSimApi: null,
      gridOptions: {
        defaultColDef: {
          headerClass: 'table-header',
          autoHeight: true
        },
        headerHeight: 40,
        localeText: AG_GRID_LOCALE_RU
      },
      changePassForm: {
        currentPass: null,
        newFirstPass: null,
        newSecondPass: null
      },
      genders: [
        { value: 'm', text: 'М' },
        { value: 'f', text: 'Ж' }
      ],
      profileUserId: null,
      uploadedAvatar: null,
      defaultAvatar: '/images/account/default.jpg',
      isAvatarRemoved: false,
      countriesOption: COUNTRIES,
      averageMarksOption: Array.from({ length: (5 - 2) / 0.1 + 1 },(value, index) => Math.round((2 + index * 0.1)*100)/100)
    }
  },
  mixins: [UserMixin],
  beforeMount() {
    this.windowWidth = window.innerWidth
    window.onresize = () => {
      this.windowWidth = window.innerWidth
    }
  },
  mounted() {
    if (this.$router.currentRoute.path === '/profile') {
      this.profileUserId = this.currUser.id
    } else {
      this.profileUserId = this.$route.params.id
    }
    this.getData()
  },
  beforeRouteUpdate(to, from, next) {
    this.profileUserId = to.params.id
    this.rowDataOlympic = null
    this.isAvatarRemoved = false
    this.rowDataCourses = null
    this.getData()
    next()
  },
  beforeRouteLeave(to, from, next) {
    this.rowDataOlympic = null
    this.isAvatarRemoved = false
    this.rowDataCourses = null
    if (to.path === '/profile') {
      this.profileUserId = this.currUser.id
      this.getData()
    } else if (to.path.includes('student/list') && to.params.id) {
      this.profileUserId = to.params.id
      this.getData()
    }
    next()
  },
  computed: {
    ...mapGetters({
      profile: 'user/getProfile',
      hasRole: 'currentUser/hasRole',
      currUser: 'currentUser/getCurrentUser',
      organizations: 'dicts/getOrganizations'
    }),
    initials() {
      let nameString = this.profile.surname
      if (this.profile.name) {
        nameString += ` ${this.profile.name[0]}.`
      }
      if (this.profile.midname) {
        nameString += ` ${this.profile.midname[0]}.`
      }
      return nameString
    },
    roles() {
      let stringRoles = ''
      let role = ''
      for (let i = 0; i < this.profile.roles.length - 1; i++) {
        role = this.$_userMixin_roleTranslate(this.profile.roles[i].title)
        stringRoles += `${role}, `
      }
      role = this.$_userMixin_roleTranslate(this.profile.roles[this.profile.roles.length - 1].title)
      stringRoles += role
      return stringRoles
    },
    portfolioRows() {
      if (this.profileUserId === this.currUser.id) {
        return (this.windowWidth < 767 && this.windowWidth > 570) ? 17 : 3
      }
      return (this.windowWidth < 767 && this.windowWidth > 570) ? 19 : 3
    },
    classesForInputs2_5() {
      return {
        'col-md-4': this.windowWidth > 1250,
        'col-md-6': this.windowWidth <= 1250
      }
    },
    classesForInput6() {
      return {
        'col-md-3': this.windowWidth > 1250,
        'col-md-4': this.windowWidth <= 1250
      }
    },
    classesForInput7() {
      return {
        'col-md-3': this.windowWidth > 1250,
        'col-md-5': this.windowWidth <= 1250
      }
    },
    classesForInput8() {
      return {
        'col-md-2': this.windowWidth > 1250,
        'col-md-3': this.windowWidth <= 1250
      }
    },
    classesForInput9() {
      return {
        'col-md-2': this.windowWidth > 1250 && this.profile.studentProfile,
        'col-md-4': this.windowWidth > 1250 && !this.profile.studentProfile,
        'col-md-5': this.windowWidth <= 1250

      }
    },
    classesForInput10() {
      return {
        'col-md-4': this.windowWidth > 1250 && this.profile.studentProfile,
        'col-md-6': this.windowWidth > 1250 && !this.profile.studentProfile,
        'col-md-5': this.windowWidth <= 1250 && !this.profile.studentProfile,
        'col-md-7': this.windowWidth <= 1250 && this.profile.studentProfile

      }
    },
    classesForInput11() {
      return {
        'col-md-2': true
      }
    },
    classesForInput12() {
      return {
        'col-md-12': true,
        'portfolio-current': this.profileUserId === this.currUser.id,
        'portfolio-other': this.profileUserId !== this.currUser.id,
        'portfolio-other-curator': !this.hasRole('admin') && (this.profileUserId !== this.currUser.id)
      }
    },
    classesForInput13() {
      return {
        'col-md-2': true,
        'text-nowrap': true
      }
    },
    classesForInput14() {
      return {
        'text-nowrap': true,
        'col-md-2': this.windowWidth > 1250,
        'col-md-5': this.windowWidth <= 1250
      }
    },
    classesForOlympics() {
      return {
        'olympic-current': this.profileUserId === this.currUser.id && !(!this.hasRole('admin') && (this.profileUserId !== this.currUser.id)),
        'olympic-other': this.profileUserId !== this.currUser.id && !(!this.hasRole('admin') && (this.profileUserId !== this.currUser.id)),
        'olympic-other-curator': !this.hasRole('admin') && (this.profileUserId !== this.currUser.id)
      }
    },
    classesForCourses() {
      return {
        'courses-current': this.profileUserId === this.currUser.id,
        'courses-other': this.profileUserId !== this.currUser.id
      }
    },
    classesForSim() {
      return {
        'sim-current': this.profileUserId === this.currUser.id,
        'sim-other': this.profileUserId !== this.currUser.id
      }
    },
    classesForAll() {
      return {
        'current-user-profile': this.profileUserId === this.currUser.id,
        'other-user-profile': this.profileUserId !== this.currUser.id
      }
    }
  },
  methods: {
    ...mapActions({
      fetchProfile: 'user/fetchProfile',
      updateProfile: 'user/updateProfile',
      uploadFiles: 'workspace/uploadFiles',
      fetchCurrentUser: 'currentUser/fetchCurrentUser',
      pushToasts: 'toasts/pushToasts',
      changePassword: 'user/changePassword'
    }),
    getData() {
      this.fetchProfile(this.profileUserId).then((data) => {
        if (data) {
          this.$router.push('/page_not_exist')
        } else {
          if (this.profile.roles[0].title === 'student') {
            const olympiads = []
            for (const olymp of this.profile.olympiads) {
              for (const olympSubj of olymp.olympiadParticipations) {
                olympiads.push({
                  title: `${olymp.title} - ${olymp.yearStart}-${olymp.yearEnd}`,
                  subjectOlympiad: olympSubj.subject,
                  stageOlympiad: olympSubj.stage,
                  resultOlympiad: `${olympSubj.result}${(olympSubj.diplomType === 'Нет')
                    ? ''
                    : `, ${olympSubj.diplomType}`}`
                })
              }
            }
            this.rowDataOlympic = olympiads.concat(this.profile.participatedEvents)
            for (let i = 0; i < this.rowDataOlympic.length; i++) {
              this.rowDataOlympic[i].numb = i + 1
            }
            this.rowDataCourses = this.profile.courses
            for (let i = 0; i < this.rowDataCourses.length; i++) {
              const countDone = Object
                .values(this.rowDataCourses[i].progress).filter((value) => value).length
              this.rowDataCourses[i].progressCourse = `${Math.round((countDone
                / this.rowDataCourses[i].subSectionsCount) * 100)}%`
              this.rowDataCourses[i].title = this.rowDataCourses[i]['course.contentObject.title']
              this.rowDataCourses[i].numb = i + 1
            }
          }
          this.isLoaded = true
        }
      })
    },
    onColumnResizedCourse() {
      this.gridCourseApi.resetRowHeights()
    },
    onColumnResizedOlympic() {
      this.gridOlympicApi.resetRowHeights()
    },
    onColumnResizedSim() {
      this.gridSimApi.resetRowHeights()
    },
    onGridReadyCourse(params) {
      this.gridCourseApi = params.api
      this.gridCourseApi.sizeColumnsToFit()
    },
    onGridReadyOlympic(params) {
      this.gridOlympicApi = params.api
      this.gridOlympicApi.sizeColumnsToFit()
    },
    onGridReadySim(params) {
      this.gridSimApi = params.api
      this.gridSimApi.sizeColumnsToFit()
    },
    getSelectedRowsOlympic() {
    },
    getSelectedRowsCourse() {
      const selectedNodes = this.gridCourseApi.getSelectedNodes()
      const selectedData = selectedNodes.map((node) => node.data)
      this.$router.push(`/education/${selectedData[0]['course.id']}`)
    },
    onGridSizeChangedOlympic() {
      this.gridOlympicApi.sizeColumnsToFit()
    },
    onGridSizeChangedCourse() {
      this.gridCourseApi.sizeColumnsToFit()
    },
    onGridSizeChangedSim() {
      this.gridSimApi.sizeColumnsToFit()
    },
    onSubmit(evt) {
      evt.preventDefault()
      document.getElementById('buttonSave').style.display = 'none'
      document.getElementById('buttonCancel').style.display = 'none'
      document.getElementById('buttonChangeMod').style.display = 'inline-block'
      this.changeMod = false
      const updatedProfile = {
        id: this.profileUserId,
        name: this.profile.name,
        surname: this.profile.surname,
        midname: this.profile.midname,
        phone: this.profile.phone,
        birthday: this.profile.birthday ? this.profile.birthday : null,
        gender: this.profile.gender,
        isEmailNotification: this.profile.isEmailNotification,
      }
      if (this.profile.roles[0].title === 'student') {
        updatedProfile.about = this.profile.studentProfile.about
        updatedProfile.citizenship = this.profile.studentProfile.citizenship
        updatedProfile.averageMarks = this.profile.studentProfile.averageMarks
      }
      if (!this.uploadedAvatar) {
        if (this.isAvatarRemoved) {
          updatedProfile.avatar = null
        } else {
          updatedProfile.avatar = this.profile.avatar
        }
        this.updateProfile(updatedProfile).then((response) => {
          if (response.data.errors) {
            this.pushToasts({
              title: 'Уведомление',
              error: true,
              message: 'Во время обновления полей профиля произошла ошибка. Данные не были изменены.',
              time: 10
            })
          } else {
            this.fetchProfile(this.profileUserId).then(() => {
              this.fetchCurrentUser()
              this.pushToasts({ title: 'Уведомление', message: 'Изменение полей профиля прошло успешно.', time: 10 })
            })
          }
        })
      } else {
        this.uploadFiles([this.uploadedAvatar]).then((ids) => {
          if (ids.data.errors) {
            this.pushToasts({
              title: 'Уведомление',
              error: true,
              message: 'Во время загрузки изображения произошла ошибка. Попробуйте ещё раз.',
              time: 10
            })
            updatedProfile.avatar = this.profile.avatar
            document.getElementById('profilePhoto').setAttribute('src', this.profile.avatarFile
              ? (`/api/files/${this.profile.avatarFile.physicalName}`) : this.defaultAvatar)
          } else {
            updatedProfile.avatar = ids.data[0].id
          }
          this.updateProfile(updatedProfile).then((response) => {
            if (response.data.errors) {
              this.pushToasts({
                title: 'Уведомление',
                error: true,
                message: 'Во время обновления профиля произошла ошибка. Данные не были изменены.',
                time: 10
              })
            } else {
              this.fetchProfile(this.profileUserId).then(() => {
                this.fetchCurrentUser()
                this.pushToasts({ title: 'Уведомление', message: 'Изменение профиля прошло успешно.', time: 10 })
              })
            }
          })
          this.uploadedAvatar = null
          this.isAvatarRemoved = false
        })
      }
    },
    onReset(evt) {
      evt.preventDefault()
      document.getElementById('buttonSave').style.display = 'none'
      document.getElementById('buttonCancel').style.display = 'none'
      document.getElementById('buttonChangeMod').style.display = 'inline-block'
      this.changeMod = false
      this.fetchProfile(this.profileUserId).then(() => {
        document.getElementById('profilePhoto').setAttribute('src', this.profile.avatarFile
          ? (`/api/files/${this.profile.avatarFile.physicalName}`) : this.defaultAvatar)
      })
    },
    changeModActive() {
      document.getElementById('buttonSave').style.display = 'inline-block'
      document.getElementById('buttonCancel').style.display = 'inline-block'
      document.getElementById('buttonChangeMod').style.display = 'none'
      this.changeMod = true
    },
    loadImage(input) {
      if (this.changeMod && input.files && input.files[0]) {
        if (input.files[0].type.split('/')[0] !== 'image' || !['jpg', 'png', 'jpeg'].includes(input.files[0].type.split('/')[1])) {
          this.pushToasts({
            title: 'Уведомление',
            error: true,
            message: `При загрузке возникла ошибка. Файл: ${input.files[0].name} не был загружен в связи с несоответствием типа!`
          })
        } else if ((input.files[0].size / 1024) / 1024 > 5) {
          this.pushToasts({
            title: 'Уведомление',
            error: true,
            message: `При загрузке возникла ошибка. Файл:${input.files[0].name} не был загружен в связи с превышением максимального размера!`
          })
        } else {
          const reader = new FileReader()
          reader.onload = function (e) {
            document.getElementById('profilePhoto').setAttribute('src', e.target.result)
          }
          reader.readAsDataURL(input.files[0])
          this.uploadedAvatar = input.files[0]
          this.isAvatarRemoved = false
        }
        this.$refs['file-input'].reset()
      }
    },
    changeImage() {
      if (this.changeMod) {
        document.getElementById('imageFileInput').click()
      }
    },
    dropImage() {
      document.getElementById('profilePhoto').setAttribute('src', this.defaultAvatar)
      this.uploadedAvatar = null
      this.isAvatarRemoved = true
    },
    closeModalChangePassword(evt) {
      evt.preventDefault()
      this.changePassForm = {
        currentPass: null,
        newFirstPass: null,
        newSecondPass: null
      }
      this.$refs['modal-change-password'].hide()
    },
    onSubmitChangePass(evt) {
      evt.preventDefault()
      if (!this.changePassForm.newFirstPass || !this.changePassForm.newSecondPass
        || !this.changePassForm.currentPass) {
        this.pushToasts({
          title: 'Уведомление',
          error: true,
          message: 'Заполните все поля!',
          time: 10
        })
      } else if (this.changePassForm.newFirstPass !== this.changePassForm.newSecondPass) {
        this.pushToasts({
          title: 'Уведомление',
          error: true,
          message: 'Введённые пароли не совпадают. Введите новый пароль ещё раз.',
          time: 10
        })
        this.changePassForm.newFirstPass = null
        this.changePassForm.newSecondPass = null
      } else {
        this.changePassword({
          oldPassword: this.changePassForm.currentPass,
          newPassword1: this.changePassForm.newFirstPass,
          newPassword2: this.changePassForm.newSecondPass
        }).then((response) => {
          if (response.data.errors) {
            if (response.status === 406) {
              this.pushToasts({
                title: 'Уведомление',
                error: true,
                message: 'Был введён неправильный текущий пароль. Пароль не был изменён.',
                time: 10
              })
            } else {
              this.pushToasts({
                title: 'Уведомление',
                error: true,
                message: 'Во время изменения пароля произошла ошибка. Пароль не был изменён.',
                time: 10
              })
            }
          } else {
            this.pushToasts({
              title: 'Уведомление',
              message: 'Пароль успешно изменён.',
              time: 10
            })
            this.changePassForm = {
              currentPass: null,
              newFirstPass: null,
              newSecondPass: null
            }
            this.$refs['modal-change-password'].hide()
          }
        })
      }
    },
    goToMessages() {
      this.$router.push(`/messages/chats/${this.profile.id}`)
    }
  }
}
</script>

<style>
  .profile-header {
    min-width: 500px;
    width: 80%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  @media screen and (min-width: 767px) and (max-width: 1250px) {
    #input-group-12 {
      position: absolute;
      left: 16px;
      width: calc(100% - 42px);
    }

    .portfolio-current {
      top: 500px;
    }

    .portfolio-other {
      top: 550px;
    }

    .portfolio-other-curator {
      top: 400px
    }

    /* #olympicDiv {
      margin-top: 120px;
    } */
    .olympic-current {
      margin-top: 120px;
    }

    .olympic-other {
      margin-top: 120px;
    }

    .olympic-other-curator {
      margin-top: 200px;
    }
  }

  @media screen and (min-width: 570px) and (max-width: 767px) {
    #input-group-12 {
      position: absolute;
      left: 16px;
      width: 280px;
    }

    .portfolio-current {
      top: 452px;
    }

    .portfolio-other {
      top: 383px;
    }

    .olympic-current {
      margin-top: 50px;
    }

    .olympic-other {
      margin-top: 50px;
    }

    .olympic-other-curator {
      margin-top: 300px;
    }
  }

  #olympicDiv, #coursesDiv, #simDiv {
    min-width: 250px;
    margin-right: 10px;
    margin-bottom: 20px;
    
  }

  .custom-select:disabled {
    color: black !important;
  }

  .buttonsFormBlock {
    width: 100%;
    min-width: 250px;
  }

  #buttonChangePassword, #buttonChangeMod, #buttonGoToMessages {
    width: 100%;
    margin-top: 5px
  }

  #buttonSave, #buttonCancel {
    width: 49%;
    margin-top: 5px;
    display: none;
  }

  #buttonSubmitChangePassword, #buttonCancelChangePassword {
    width: 49%;
    margin-top: 5px;
  }

  #buttonSave, #buttonSubmitChangePassword {
    margin-right: 2%;
  }

  #profilePhoto {
    height: 250px;
    max-width: 250px;
  }

  #input-group-1 {
    float: left;
    width: 250px;
    min-width: 250px;
  }

  .change-profile-avatar-button {
    top: 10px;
    right: 50px;
  }

  .delete-profile-avatar-button {
    top: 10px;
    right: 10px;
  }
  @media screen and (max-width: 570px) {
    .change-profile-avatar-button {
      right: calc(50% - 125px + 50px);
    }
    .delete-profile-avatar-button {
      right: calc(50% - 125px + 10px);
    }

    #input-group-1 {
      float: none;
      width: 100%;
    }
    #input-group-1 label {
      width: 100%;
    }
    .buttonsFormBlock {
      width: 250px;
      margin: auto;
    }
    .profile-photo-div {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
    }
  }

  .ag-grid-vue-profile
  .ag-row .ag-cell {
    padding-left: 25px !important;
    white-space: normal !important;
  }

  .table-header {
    font-size: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    color: white;
  }

  .table-header:hover {
    background-color: #017ac3 !important;
  }

  .ag-grid-vue-profile .ag-header-viewport {
    background-color: #017ac3 !important;
  }

  .ag-grid-vue-profile .ag-center-cols-viewport {
    border-bottom: 1px solid #017ac3 !important;
  }

  .ag-grid-vue-profile {
    background-color: #f8fafc !important;
  }

</style>
